import PropTypes from "prop-types";
import "./TransferRegistration.css";

const TransferSidebar = ({
  stages,
  currentStep,
  currentStageStep,
  completedSteps,
  onNavigateToStep,
  draft,
}) => {
  const isCompleted = (stageStep) => completedSteps?.has(stageStep);

  return (
    <aside className="">
      <div className="ui-panel">
        <h6 className="ui-panel__header mb-3">Steps</h6>

        <div className="transfer-stepper mb-4">
          {stages.map((stage) => {
            const isCurrent = stage.step === currentStageStep;
            const done = isCompleted(stage.step);
            const clickable = typeof onNavigateToStep === "function" && stage.step < currentStep;
            return (
              <button
                key={stage.label}
                type="button"
                className={`transfer-step btn w-100 text-start ${isCurrent ? "is-current" : ""} ${done ? "is-done" : ""}`}
                onClick={() => {
                  if (clickable) onNavigateToStep(stage.step);
                }}
                disabled={!clickable}
              >
                <span className="transfer-step__status">
                  {done ? <i className="bi bi-check-circle-fill text-success" aria-hidden /> : <span className="transfer-step__dot" aria-hidden />}
                </span>
                <span className="transfer-step__label">{stage.label}</span>
              </button>
            );
          })}
        </div>

      </div>
    </aside>
  );
};

TransferSidebar.propTypes = {
  stages: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  currentStageStep: PropTypes.number.isRequired,
  completedSteps: PropTypes.instanceOf(Set),
  onNavigateToStep: PropTypes.func,
  draft: PropTypes.object,
};

export default TransferSidebar;
